import React from 'react'
import styled from 'styled-components'
import { CardContent, Card } from '@mui/material'
import collection0 from '../../assets/Illustration_Microsoft_Office.svg'
import collection1 from '../../assets/Illustration_SalesForce.svg'
import collection2 from '../../assets/Illustration_WorkFromHome.svg'

const Collection = styled.div`
  @media (min-width: 0px) and (max-width: 900px){
    margin-top: 25px;
  }
  margin-top: 68px;
`
const CollectionTitle = styled.div`
font-family: "AeonikPro-Regular";
font-style: normal;
font-weight: 600;
font-size: 24px;
line-height: 36px;
color: #35324A;
@media (min-width: 0px) and (max-width: 450px){
  margin-left: 12px;
}

`
const CollectionCard = styled.div`
display: inline-flex;
margin-top:20px;
@media (min-width: 0px) and (max-width: 450px) {
  flex-direction: column;
  width: 100%
};
@media (min-width: 451px) and (max-width: 900px) {
  flex-direction: row;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  overflow-x: scroll;
};
@media (min-width: 901px) and (max-width: 1349px){
  margin-top: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  overflow-x: scroll;
}

`

const CollectionCardTitle = styled.div`
font-family: "AeonikPro-Medium";
font-size: 20px;
font-weight: 500;
color: #25233B;
margin-left : 15px;
line-height: 26px;
height : 57.42px;
padding-top: 16px;
`

const CollectionsLogo = styled.img`
height: 93.25px;
`
interface IProps {
    collectionsList : never[]
    applyCollectionsFilter :(collectionName: string) => void
}

const Collections = (props: IProps) => {
  const CollectionImg = [collection2, collection0, collection1]

  return (
    <Collection>
    <CollectionTitle>Collections</CollectionTitle>
    <CollectionCard>
      {
        props.collectionsList.map((collection, index) => {
          return <Card
            key={collection}
            sx={{
              width: '285px',
              fontFamily: 'AeonikPro-Regular',
              height: '150px',
              backgroundColor: '#E8E8E8',
              borderRadius: '8px',
              marginRight: '20px',
              'box-shadow': '0px 8px 16px rgba(0, 0, 0, 0.1)',
              background: 'white',
              padding: '0px',
              cursor: 'pointer',
              '@media (min-width: 0px) and (max-width: 450px)': {
                width: '95%',
                marginLeft: '12px',
                marginBottom: '16px'
              },
              '@media (min-width: 451px) and (max-width: 900px)': {
                marginRight: '10px',
                marginBottom: '16px'
              },
              ':hover': { boxShadow: '0px 8px 12px rgba(115, 115, 115, 0.25)' }

            }}
            onClick={() => props.applyCollectionsFilter(collection)}>
            <CardContent sx={{ display: 'flex', padding: '0px', flexDirection: 'column' }}>
            <CollectionsLogo src={CollectionImg[index]} />
              <CollectionCardTitle>
                {collection}
              </CollectionCardTitle>
            </CardContent>
          </Card>
        })
      }
    </CollectionCard>
  </Collection>
  )
}

export default Collections
